import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useInView, IntersectionOptions } from 'react-intersection-observer';
import { TOTAL_PAGINATION } from 'src/constants';
import useList, { ListActions } from './useList';
import { IListState } from './useList/store';
import { reFetchAdNative } from 'src/redux/actions/ad';

const DEFAULT_OPTIONS: IntersectionOptions = {
    threshold: 0,
    rootMargin: '50px',
};

export function useIntersectionLoader<T>(
    fetchFn: (...params: any) => any,
    initState?: object,
    intersectionOptions: IntersectionOptions = {},
    startPage: number = 0,
    limitLoadmore: boolean = true
): [any, IListState<T>, ListActions] {
    const [list, listActions] = useList<T>({ fetchFn, initState });

    const dispatch = useDispatch();
    const options = Object.assign({
        DEFAULT_OPTIONS,
        intersectionOptions,
    });

    const [loaderRef, inView] = useInView(options);

    useEffect(() => {
        if (list.hasMore && inView && !list.isFetching) {
            if (
                !limitLoadmore ||
                startPage + TOTAL_PAGINATION > list.currentPage
            ) {
                dispatch(reFetchAdNative());
                listActions.onPageChange(list.currentPage + 1);
            }
        }
    }, [inView, startPage]);

    return [loaderRef, list, listActions];
}
